module.exports = __webpack_public_path__ + "img/org-goals.5a569be6.svg";